export default function isLegacyDonation(state){
	return /(legacy|obits|obituaries)(\.\S+)?\.com/i.test(state.widget.articleUrl) ||
		/(remembering)(\S+)?\.us/i.test(state.widget.articleUrl) ||
		state.widget.articleUrlTracking.includes('LegacyTest');
}
